import chatquickview from "./chat-quickview.html";

const quickviewHandler = require('../quickview/quickview-handler')
const chatHandler = require('./chat-handler')
const chatActions = require('./chat-actions')

/****************ELEMENTS*****************/
var htmlQf = {}
var HTMLwasSelected = false
let data = {};

function HTMLselect(detail) {

    const sourceElement = detail.ev?.target || null;

    quickviewHandler.HTMLselect(
        'chat', //database table name****
        'chat-quickview',
        sourceElement, //source, for example AC
        chatquickview,
        htmlQf
    )

    HTMLwasSelected = true
}

export function start(detail) {
    if (!HTMLwasSelected) { HTMLselect(detail) }
    obj[detail.actQuickview].start(detail)
}

const obj = {

    show: { start: (detail) => { show(detail) } },
    hide: { start: (detail) => { quickviewHandler.hide(detail, htmlQf) } },
    submit: { start: (detail) => { submit(detail) } },
}

function show(detail) {
    // se limpia la variable general
    data = "";
    // se asigna los valores de detail a la variable general data
    data = detail;
    // se muestra el quickview para poder acceder a los elementos
    quickviewHandler.show(detail, htmlQf)
    // se limpia el chat
    chatActions.clearChat()
    // se obtienen los labels estaticos
    const quickViewChats = document.getElementById("chat-quickview");
    const typeEntity = quickViewChats.querySelector(".chat-type-entity");
    const typeName = quickViewChats.querySelector(".chat-type-name");
    // se limpian los labels antes de inserta entidad y tipo
    typeEntity.innerHTML = "";
    typeName.innerHTML = "";
    // se manejan datos especificos para ejecutar verificaciones especificas
    const recordId = data.recordId || 0;
    const question = detail.question || "";
    // si existe una pregunta al momento de mostrar el chat
    if (question !== "") {
        chatActions.setTextInput(question)
        chatHandler.submit({
            "type": data.type,
            "entity": data.entity,
            "recordId": recordId,
            "question": question,
            "data": data.data
        })
    }
    // se el id de la factura es diferente de 0
    if (recordId !== 0) {
        chatHandler.getChats({
            "type": data.type,
            "entity": data.entity,
            "recordId": recordId
        })
    }
    // se asigna el valor valor a los labels especificos
    typeEntity.innerHTML = `Entity: ${detail.entity}`;
    typeName.innerHTML = `Type: ${detail.type}`;
    // se limpia la caja de escritura
    chatActions.clearTextInput()
}

function submit(detail) {
    const question = chatActions.getTextInput(detail);
    if (question === '') return;

    chatHandler.submit({
        "type": data.type,
        "entity": data.entity,
        "recordId": data.recordId ?? "0",
        "question": question,
        "data": data.data
    })
}